import { InstallType } from '@helpers/pwa';
import Spacer from '@components/Spacer';
import s from './GetNoodleAppModal.module.scss';

type Props = {
  doInstall: () => void | Promise<void>;
  isReadyToInstall: boolean;
  isInApp: boolean;
  installType: InstallType;
};

const Description: React.FC<Props> = ({ isInApp, installType }) => {
  if (isInApp) {
    return <p className={s.grayCaption}>Thanks for already using the Glade App!</p>;
  }

  if (installType === 'apple-share-button') {
    return (
      <>
        <p className={s.grayCaption}>
          Add the Glade Dashboard directly to your phone home screen, to quickly and easily access all the tools you need to run your business. This
          app is no different from a regular app on your phone, just lighter and faster.
        </p>
        <Spacer size="24px" />
        <section className={s.iOSguide}>
          <div>
            <small>1</small>
            <p>
              Tap <strong>Share</strong> button
            </p>
          </div>
          <div className={s.iOSguideShare}>
            <div>
              <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.75 10V26C21.75 26.4641 21.5656 26.9092 21.2374 27.2374C20.9092 27.5656 20.4641 27.75 20 27.75H2C1.53587 27.75 1.09075 27.5656 0.762563 27.2374C0.434375 26.9092 0.25 26.4641 0.25 26V10C0.25 9.53587 0.434375 9.09075 0.762563 8.76256C1.09075 8.43437 1.53587 8.25 2 8.25H5C5.19891 8.25 5.38968 8.32902 5.53033 8.46967C5.67098 8.61032 5.75 8.80109 5.75 9C5.75 9.19891 5.67098 9.38968 5.53033 9.53033C5.38968 9.67098 5.19891 9.75 5 9.75H2C1.9337 9.75 1.87011 9.77634 1.82322 9.82322C1.77634 9.87011 1.75 9.9337 1.75 10V26C1.75 26.0663 1.77634 26.1299 1.82322 26.1768C1.87011 26.2237 1.9337 26.25 2 26.25H20C20.0663 26.25 20.1299 26.2237 20.1768 26.1768C20.2237 26.1299 20.25 26.0663 20.25 26V10C20.25 9.9337 20.2237 9.87011 20.1768 9.82322C20.1299 9.77634 20.0663 9.75 20 9.75H17C16.8011 9.75 16.6103 9.67098 16.4697 9.53033C16.329 9.38968 16.25 9.19891 16.25 9C16.25 8.80109 16.329 8.61032 16.4697 8.46967C16.6103 8.32902 16.8011 8.25 17 8.25H20C20.4641 8.25 20.9092 8.43437 21.2374 8.76256C21.5656 9.09075 21.75 9.53587 21.75 10ZM6.53 6.53L10.25 2.81125V17C10.25 17.1989 10.329 17.3897 10.4697 17.5303C10.6103 17.671 10.8011 17.75 11 17.75C11.1989 17.75 11.3897 17.671 11.5303 17.5303C11.671 17.3897 11.75 17.1989 11.75 17V2.81125L15.47 6.53C15.5387 6.60369 15.6215 6.66279 15.7135 6.70378C15.8055 6.74477 15.9048 6.76682 16.0055 6.76859C16.1062 6.77037 16.2062 6.75184 16.2996 6.71412C16.393 6.6764 16.4778 6.62026 16.549 6.54904C16.6203 6.47782 16.6764 6.39299 16.7141 6.2996C16.7518 6.20621 16.7704 6.10618 16.7686 6.00548C16.7668 5.90478 16.7448 5.80546 16.7038 5.71346C16.6628 5.62146 16.6037 5.53866 16.53 5.47L11.53 0.47C11.3894 0.32955 11.1988 0.25066 11 0.25066C10.8012 0.25066 10.6106 0.32955 10.47 0.47L5.47 5.47C5.39631 5.53866 5.33721 5.62146 5.29622 5.71346C5.25523 5.80546 5.23318 5.90478 5.23141 6.00548C5.22963 6.10618 5.24816 6.20621 5.28588 6.2996C5.3236 6.39299 5.37974 6.47782 5.45096 6.54904C5.52218 6.62026 5.60701 6.6764 5.7004 6.71412C5.79379 6.75184 5.89382 6.77037 5.99452 6.76859C6.09522 6.76682 6.19454 6.74477 6.28654 6.70378C6.37854 6.66279 6.46134 6.60369 6.53 6.53Z" />
              </svg>
            </div>
          </div>
        </section>
        <section className={s.iOSguide}>
          <div>
            <small>2</small>
            <p>
              Down the list tap <strong>Add to Home Screen</strong>
            </p>
          </div>
          <div className={s.iOSguideAddToHomeScreen}>
            <div />
            <div className={s.add}>
              Add to Home Screen
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="5.5" y="11.25" width="13" height="1.5" rx="0.75" />
                <rect x="12.75" y="5.5" width="13" height="1.5" rx="0.75" transform="rotate(90 12.75 5.5)"/>
                <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="3.25" strokeWidth="1.5" />
              </svg>
            </div>
            <div />
          </div>
        </section>
        <section className={s.iOSguide}>
          <div>
            <small>3</small>
            <p>Enjoy the following features:</p>
          </div>
        </section>
      </>
    );
  }

  if (installType === 'native') {
    return (
      <p className={s.grayCaption}>
        Add the Glade Dashboard directly to your phone home screen, to quickly and easily access all the tools you need to run your business. This
        app is no different from a regular app on your phone, just lighter and faster.
      </p>
    );
  }

  return <p className={s.grayCaption}>Sorry, but we can not install the app on this device.</p>;
};

export default Description;
